<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="buttonLoading"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>cloud_download</v-icon>Export
              </v-btn>
            </template>

            <v-list>
              <v-list-tile @click="exportProductSaleReportBySaleTeamExcel()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3 v-if="user.role.roleName != 'GENERAL_MANAGER'">
              <v-select
                :items="shopList"
                label="Choose Shop..."
                item-text="name"
                menu-props="auto"
                item-value="id"
                :readonly="user.role.roleName == 'BRANCH_ADMIN'"
                v-model="queryParams.shopId"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                v-model="queryParams.productIds"
                :items="selectedProductList"
                label="Product"
                @click="showProducts()"
                item-text="code"
                item-value="id"
                multiple
                menu-props="auto"
                autocomplete
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                v-model="queryParams.saleTeamId"
                :items="saleTeamList"
                label="Sale Team"
                item-text="name"
                item-value="id"
                menu-props="auto"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title class="blue darken-3">
            <span class="headline white--text">Summary</span>
            <v-spacer></v-spacer>
            <v-icon @click="show = !show" class="white--text">{{
              show ? "keyboard_arrow_up" : "keyboard_arrow_down"
            }}</v-icon>
          </v-card-title>
          <v-card-text class="font-weight-bold" v-show="show">
            <div>
              <span>Total Sale Qty:</span>
              <v-chip>
                <span>{{ totalSaleQty | decFormat(6) }}</span>
              </v-chip>
              <span>Total FOC Qty:</span>
              <v-chip>
                <span>{{ totalFocQty | decFormat(6) }}</span>
              </v-chip>
              <span>Total Return Qty:</span>
              <v-chip>
                <span>{{ totalReturnQty | decFormat(6) }}</span>
              </v-chip>
            </div>
            <div>
              <span>Total Sale Amount:</span>
              <v-chip>
                <span>{{ totalSaleAmount | decFormat(6) }}</span>
              </v-chip>
              <span>Total Sale Return Amount:</span>
              <v-chip>
                <span>{{ totalSaleReturnAmount | decFormat(6) }}</span>
              </v-chip>
              <span>Total Net Amount:</span>
              <v-chip>
                <span>{{ totalNetAmount | decFormat(6) }}</span>
              </v-chip>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="productSaleReportBySaleTeamList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.productCode }}</td>
              <td>{{ props.item.productName }}</td>
              <td>{{ props.item.unitName }}</td>
              <td style="text-align: right">
                {{ props.item.saleQty | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.focQty | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.returnQty | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.saleAmount | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.returnAmount | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.netAmount | decFormat(6) }}
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Product list dialog -->
    <v-dialog v-model="showProductListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="productQueryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="name"
                label="Name"
                type="text"
                class="mr-1"
                v-model="productQueryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="brandName"
                label="Brand"
                type="text"
                class="mr-1"
                v-model="productQueryParams.brandName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="categoryName"
                label="Category"
                type="text"
                class="mr-1"
                v-model="productQueryParams.categoryName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="productGroupName"
                label="Product Group"
                type="text"
                class="mr-1"
                v-model="productQueryParams.productGroupName"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearchProduct">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Product List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                v-model="selectedProductList"
                :headers="productHeaders"
                :items="productList"
                select-all
                class="elevation-1"
                :loading="showListLoading"
                :total-items="producttotalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="productpagination"
                :must-sort="true"
              >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th>
                      <v-checkbox
                        primary
                        hide-details
                        @click.native="toggleAll"
                        :input-value="props.all"
                        :indeterminate="props.indeterminate"
                      ></v-checkbox>
                    </th>
                    <th v-for="header in props.headers" :key="header.text">
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <template slot="items" slot-scope="props">
                  <td>
                    <v-checkbox
                      primary
                      hide-details
                      :input-value="props.selected"
                      :value="props.item"
                      :indeterminate="props.indeterminate"
                      v-model="selectedProductList"
                      multiple
                    ></v-checkbox>
                  </td>
                  <td>
                    <a>{{ props.item.code }}</a>
                  </td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.brand.name }}</td>
                  <td>{{ props.item.category.name }}</td>
                  <td v-if="props.item.productGroup">
                    {{ props.item.productGroup.name }}
                  </td>
                  <td v-else></td>
                  <td>{{ props.item.description }}</td>
                </template>
              </v-data-table>
              <div class="text-xs-right">
                <v-btn color="primary" @click="setProduct">Ok</v-btn>
              </div>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End dialog -->
  </v-container>
</template>

<script>
import { commonService } from "../../services/common-service";
import { productService } from "../../services/product-service";
import { productSaleReportBySaleTeamService } from "../../services/product-sale-report-by-sale-team-service";
import { shopService } from "../../services/shop-service";
import { saleTeamService } from "../../services/sale-team-service";

export default {
  name: "ProductSaleReportBySaleTeam",

  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    buttonLoading: false,
    show: false,
    showFilters: false,
    showProductListDialog: false,
    breadcrumbs: [
      {
        text: "Report",
        disabled: true,
      },
      {
        text: "Sale Reports",
        disabled: true,
      },
      {
        text: "Product Sale Report By Sale Team",
        disabled: true,
      },
    ],
    headers: [
      { text: "Product Code", align: "left", sortable: false },
      { text: "Product Name", align: "left", sortable: false },
      { text: "Unit", align: "left", sortable: false },
      { text: "Sale Qty", align: "right", sortable: false },
      { text: "Foc Qty", align: "right", sortable: false },
      { text: "Return Qty", align: "right", sortable: false },
      { text: "Sale Amount", align: "right", sortable: false },
      { text: "Sale Return Amount", align: "right", sortable: false },
      { text: "Net Amount", align: "right", sortable: false },
    ],
    productHeaders: [
      { text: "Code", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Brand", value: "brand.name" },
      { text: "Category", value: "category.name" },
      { text: "Product Group", value: "productGroup.name" },
      { text: "Description", value: "description" },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      sortBy: "",
      totalItems: 0,
    },
    totalRows: 0,
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      productIds: [],
      saleTeamId: "",
      shopId: "",
    },
    productSaleReportBySaleTeamList: [],
    saleTeamList: [],
    shopList: [],

    totalSaleQty: 0,
    totalFocQty: 0,
    totalReturnQty: 0,
    totalSaleAmount: 0,
    totalSaleReturnAmount: 0,
    totalNetAmount: 0,

    clonequeryParams: new Object(),
    productList: [],
    productQueryParams: {
      name: "",
      code: "",
      status: "ACTIVE",
      brandName: "",
      categoryName: "",
      productGroupName: "",
    },
    productpagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "code",
      totalItems: 0,
    },
    producttotalRows: 0,
    selectedProductList: [],
    findAll: { id: "", name: "----All----" },
  }),
  watch: {
    pagination: {
      handler() {
        this.getProductSaleReportBySaleTeam();
        this.getProductSaleReportBySaleTeamSummary();
      },
      deep: true,
    },
    productpagination: {
      handler() {
        this.getProductList();
      },
      deep: true,
    },
  },

  created() {
    if (
      this.user.role.roleName == "GENERAL_MANAGER" ||
      this.user.role.roleName == "BRANCH_ADMIN"
    ) {
      this.queryParams.shopId = this.user.shopId;
    }
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getAllShop();
    this.getActiveSaleTeams();
    this.onSearch();
  },
  methods: {
    getAllShop() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
          this.shopList.unshift(this.findAll);
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },
    getActiveSaleTeams() {
      saleTeamService
        .getSaleTeamsByStatus("ACTIVE")
        .then((res) => {
          this.saleTeamList = res.data;
          this.saleTeamList.unshift({ id: "0", name: "---No Sale Team---" });
          this.saleTeamList.unshift(this.findAll);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "product-sale-report-by-sale-team",
        query: this.queryParams,
      });
      this.getProductSaleReportBySaleTeam();
      this.getProductSaleReportBySaleTeamSummary();
      this.clonequeryParams = JSON.parse(JSON.stringify(this.queryParams));
    },

    getProductSaleReportBySaleTeam() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      productSaleReportBySaleTeamService
        .getProductSaleReportBySaleTeam(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.productSaleReportBySaleTeamList =
              res.data.productSaleReportBySaleTeamList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    getProductSaleReportBySaleTeamSummary() {
      productSaleReportBySaleTeamService
        .getProductSaleReportBySaleTeamSummary(this.queryParams)
        .then((res) => {
          if (res.data) {
            this.totalSaleQty = res.data.totalSaleQty;
            this.totalFocQty = res.data.totalFocQty;
            this.totalReturnQty = res.data.totalReturnQty;
            this.totalSaleAmount = res.data.totalSaleAmount;
            this.totalSaleReturnAmount = res.data.totalSaleReturnAmount;
            this.totalNetAmount = res.data.totalNetAmount;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    showProducts() {
      // Clean query params
      this.productQueryParams.productCode = "";
      this.productQueryParams.productName = "";
      this.productQueryParams.brandName = "";
      this.productQueryParams.categoryName = "";
      this.productQueryParams.productGroupName = "";
      this.selectedProductList = [];
      this.queryParams.productIds = [];
      this.getProductList().then(
        (this.showProductListDialog = !this.showProductListDialog)
      );
    },

    setProduct() {
      if (this.selectedProductList.length) {
        this.queryParams.productIds = [];
        this.selectedProductList.forEach((element) => {
          if (!this.queryParams.productIds.includes(element.id))
            this.queryParams.productIds.push(element.id);
        });
      }
      this.showProductListDialog = !this.showProductListDialog;
    },

    onSearchProduct() {
      this.productQueryParams.page = this.productpagination.page;
      this.productQueryParams.size = this.productpagination.rowsPerPage;
      this.getProductList();
    },
    getProductList() {
      this.showListLoading = true;
      let order = this.productpagination.descending ? "desc" : "asc";
      return productService
        .getProductList(
          this.productQueryParams,
          this.productpagination.page,
          this.productpagination.rowsPerPage,
          this.productpagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.productList = res.data.productList;
            this.producttotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    toggleAll() {
      if (this.selectedProductList.length) {
        this.selectedProductList = [];
      } else {
        this.selectedProductList = this.productList.slice();
      }
    },

    exportProductSaleReportBySaleTeamExcel() {
      this.buttonLoading = true;
      productSaleReportBySaleTeamService
        .exportProductSaleReportBySaleTeamExcel(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
  },
};
</script>
